export default __webpack_public_path__ + "static/media/invoices.d896c43c.svg";